<script>
import FormCandidate from "../../atoms/FormCandidate.vue";
import BasicButton from "../../../../theme/atoms/BasicButton.vue";

export default {
    name: "SendPasswordResentLinkForm",
    components: {FormCandidate, BasicButton},
    props: {
        candidate: {
            type: Object,
            required: false
        },
        message: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            submitting: false,
            errors: null
        }
    },
    methods: {
        handleSubmit() {
            this.submitting = true;
            axios.post('/auth/forgot-password', {username: this.candidate.username})
                .then(({data}) => {
                    this.$emit('forgot-password-success', data.message);
                }).catch(({response}) => {
                this.errors = response.data.errors;
            }).finally(() => {
                this.submitting = false;
            });
        }
    },
}
</script>

<template>
    <div class="d-flex flex-column align-items-center gap-3 w-100">
        <form-candidate :candidate="candidate"/>
        <basic-button class="btn-primary" @click="handleSubmit" :text="trans('Send Password Reset Link')" :loading="submitting" />
    </div>
</template>
